"use strict";

const BOOKS_BANNER_TEMPLATE = `
    <% if (this.collection && this.collection.length > 0) { %>
    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
        <i class="fa fa-angle-left fa-4x"></i>
    </div>
    <div id="banner" class="col-lg-10 col-md-10 col-sm-10 col-xs-10">
        <% this.collection.forEach(function(book) { %>
            <figure>
                <img src="./assets/images/<%= book.get('img') %>">
                <figcaption>
                    <a href="index.html#<%= app.getLanguage() %>/book/<%= book.get('book_id') %>">
                        <h4 class="book-title m0"><%= BookModel.format(book.get("title"), 40) %></h4>
                    </a>
                </figcaption>
            </figure>
        <% }) %>
    </div>
    <div class="col-lg-1 col-md-1 col-sm-1 col-xs-1">
        <i class="fa fa-angle-right fa-4x"></i>
    </div>
    <% } else { %>
        <h4><%= app.localeManager.get("errors.no_suggestion") %></h4>
    <% } %>
`;

const BooksBannerComponent = Backbone.View.extend({

    className: "container book-suggestions p40",

    isRendered: false,

    bannerSiema: null,

    template: _.template(BOOKS_BANNER_TEMPLATE),

    afterRender: function () {
        if (this.isRendered && this.collection && this.collection.length > 0) {
            var self = this;

            // The banner carousel
            this.bannerSiema = new Siema({
                selector: ".book-suggestions #banner",
                perPage: 2,
                loop: true,
                duration: 500,
                onInit: function () {
                    self.$el.find("#banner").show();
                }
            }).addArrows();
        }
    },

    render: function () {
        this.$el.html(this.template(this.collection));
        this.isRendered = true;

        return this;
    },

});